import { bugsnagVue } from './globals';
import { createApp } from 'vue';
import App from './App.vue';

// Third party styles
import 'emoji-mart-vue-fast/css/emoji-mart.css';

// App settings and configuration
import * as Components from './components/index';
import * as Directives from './directives/index';
import { FEATURES } from './provides/features';
import { routes } from '~/routes';

const app = createApp(App);

for (const [name, component] of Object.entries(Components)) {
    app.component(name, component);
}

for (const [name, directive] of Object.entries(Directives)) {
    app.directive(name, directive);
}

app.config.globalProperties.$cspNonce = Spark.cspNonce;
app.config.compilerOptions.whitespace = 'preserve';

app.provide('FEATURES', FEATURES);

if (bugsnagVue) {
    app.use(bugsnagVue);
}

app.use(routes).mount('#spark-app');
